import { InputAdornment, TextField } from "@mui/material";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";

const Input = (props) => {
  const {
    onChange,
    value,
    placeholder,
    disabled,
    label,
    name,
    hasPassword,
    passwordVisibility,
    setPasswordVisibility,
  } = props;

  return (
    <>
      <div className="w-full">
        <label htmlFor="email" className="block mb-2 text-sm text-blue-400">
          {label}
        </label>
        <div className="flex justify-between items-center w-full">
          <TextField
            fullWidth
            type={hasPassword && passwordVisibility ? "password" : "text"}
            name={name}
            onChange={onChange}
            value={value}
            placeholder={placeholder}
            disabled={disabled}
            InputProps={{
              endAdornment: hasPassword ? (
                <InputAdornment
                  onClick={() => {
                    setPasswordVisibility(!passwordVisibility);
                  }}
                  className="cursor-pointer hover:text-gray-300"
                >
                  {passwordVisibility ? <FaRegEye /> : <FaRegEyeSlash />}
                </InputAdornment>
              ) : null,
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Input;
